import fetch from 'isomorphic-fetch';
import { toastsActions } from '@zola-helpers/client';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

import { getUserContext } from 'selectors/user/userSelectors';
import handleZoomErrorNotifications from 'actions/helpers/handleZoomErrorNotifications';

import {
  updateEntityRequest,
  receiveEntityResponse,
  receiveUpdatedEntityResponse,
  getEntitiesRequest,
  getEntitiesResponse,
  editEntityRequest,
} from '../EntityActions';
import { receiveZoomEvent } from '../../EventActions';
import ApiService from '../../../util/api';

const ENTITY_LIST_NAME = 'events';

const handleEventErrors = (error, dispatch) => {
  if (error.status) {
    const { domain } = error.category;
    let headline;
    switch (domain) {
      case 'event':
        headline = 'Cannot Delete Event: already received RSVPs.';
        break;
      case 'meal-option':
        headline = 'Cannot Delete Meal Option: already selected by guests.';
        break;
      case 'rsvp-question':
        headline = 'Cannot Delete RSVP Question: already answered by guests.';
        break;
      default:
        headline = 'There was an with your request. Please try again.';
    }
    dispatch(toastsActions.negative({ headline }));
    throw new Error('error');
  }
  return error;
};

export const editEvent = event => dispatch => {
  dispatch(editEntityRequest(event));
};

export function getEventsV2() {
  return (dispatch, getState) => {
    const state = getState();
    const userContext = getUserContext(state);
    const currentToasts = state.toasts;
    dispatch(getEntitiesRequest());
    return fetch('/web-api/v2/cms/page/event', {
      credentials: 'same-origin',
    })
      .then(response => response.json())
      .then(response =>
        handleZoomErrorNotifications({ dispatch, response, userContext, currentToasts })
      )
      .then(json => {
        dispatch(getEntitiesResponse(json[ENTITY_LIST_NAME], json.meal_options));
        return json;
      });
  };
}

export function getEventByHash(eventHash) {
  return (dispatch, getState) => {
    const state = getState();
    const userContext = getUserContext(state);
    const currentToasts = state.toasts;
    dispatch(getEntitiesRequest());
    return fetch(`/web-api/v2/cms/page/event/${eventHash}`, {
      credentials: 'same-origin',
    })
      .then(response => response.json())
      .then(response =>
        handleZoomErrorNotifications({ dispatch, response, userContext, currentToasts })
      )
      .then(json => {
        dispatch(receiveUpdatedEntityResponse(json));
        const virtual = _get(json, 'virtual_meeting', null);
        const isVirtual = virtual && !_isEmpty(virtual);
        if (isVirtual) dispatch(receiveZoomEvent(json));
        return json;
      })
      .then(json => dispatch(editEntityRequest(json)));
  };
}

export function addEventV2(createEventRequest) {
  return dispatch => {
    dispatch(updateEntityRequest());
    return fetch('/web-api/v2/cms/events', {
      credentials: 'same-origin',
      headers: {
        'Content-type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(createEventRequest),
    })
      .then(response => response.json())
      .then(json => dispatch(receiveEntityResponse(json, true)))
      .then(() => dispatch(toastsActions.positive({ headline: 'Event Added' })));
  };
}

export function updateEventV2(updatedEventRequest) {
  return (dispatch, getState) => {
    const state = getState();
    const userContext = getUserContext(state);
    const currentToasts = state.toasts;
    dispatch(updateEntityRequest());
    return ApiService.post('/web-api/v2/cms/events/update', updatedEventRequest)
      .then(e => handleEventErrors(e, dispatch))
      .then(response =>
        handleZoomErrorNotifications({ dispatch, response, userContext, currentToasts })
      )
      .then(json => dispatch(receiveUpdatedEntityResponse(json, true)))
      .then(() => dispatch(toastsActions.positive({ headline: 'Event Updated' })));
  };
}
